import React from "react";
import { Button } from "react-bootstrap";
import { MoonStarsFill, SunFill } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../theme/ThemeContext";

export default function ThemeToggle({ variant = "outline-light", className = "" }) {
    const { theme, toggleTheme } = useTheme();
    const { t } = useTranslation();
    const label = theme === "dark" ? t("theme_light") : t("theme_dark");

    return (
        <Button
            variant={variant}
            size="sm"
            onClick={toggleTheme}
            title={label}
            aria-label={label}
            className={`d-inline-flex align-items-center justify-content-center ${className}`}
            style={{ width: 34, height: 34 }}
        >
            {theme === "dark" ? <SunFill /> : <MoonStarsFill />}
        </Button>
    );
}
